module.exports = __webpack_public_path__ + "static/img/son12.b630e03c.jpg";